import { api } from '@/shared/api/client'

export const deleteSetQuery = async (id: string) => {
	const response = await api().delete(`/v1/offers/sets/${id}`).json<null>()

	return response
}
